import ClientPortal from '../../../plugins/axios'

export default {
    hasProcedureAccess() {
        return ClientPortal.get(`${process.env.VUE_APP_API}/provider/login/has-procedure-access`)
    },
    hasAcuAccess() {
        return ClientPortal.get(`${process.env.VUE_APP_API}/provider/login/has-acu-access`)
    },
    markAcuProcDone(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/provider/login/mark-acu-proc-done`, payload)
    },
    verifyAcuApproval(payload) {
        const params = new URLSearchParams(payload).toString()
        return ClientPortal.get(`${process.env.VUE_APP_API}/provider/login/acu-verify-approval?${params}`)
    },
    getDiagnosisList(payload) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/provider/login/get-diagnosis-list`, payload)
    },
    generateApprovalDiagnosticprocedure(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/provider/login/generate-approval-diagnosticprocedure`, payload)
    },
    downloadLedger(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/provider/login/download-ledger`, payload)
    },
    getLedgerControls(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/provider/login/get-ledger-controls`, payload)
    },
    generateReport(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/provider/login/generate-report`, payload)
    },
    getLinkedProviders(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/provider/login/get-linked-providers`, payload)
    },
    getMembEmail(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/provider/login/get-memb-email`, payload)
    },
    getMembDetails(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/provider/login/get-memb-details`, payload)
    },
    getProviderAffiDoctors(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/provider/login/get-provider-affi-doctors`, payload)
    },
    recoverPassword(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/provider/login/recover-password`, payload)
    },
    forgotPassword(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/provider/login/forgot-password`, payload)
    },
    downloadApproval(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/provider/login/download-approval`, payload)
    },
    getProviderHistory(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/provider/login/get-provider-history`, payload)
    },
    changePassword(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/provider/login/change-password`, payload)
    },
    getAccountDetails(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/provider/login/get-account-details`, payload)
    },
    getMembHospClinAll(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/provider/login/get-memb-hospclin-all`, payload)
    },
    generateApprovalConsultation(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/provider/login/generate-approval-consultation`, payload)
    },
    checkPatientEligibility(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/provider/login/check-patient-eligibility`, payload)
    },
    newProvider(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/provider/signup/provider-signup`, payload)
    },
    getProviderInfo(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/provider/login/get-provider-info`, payload)
    },
    getAffiliates(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/provider/login/get-provider-hospclin`, payload)
    }
}

